import { useRef } from "react";
import { observer } from "mobx-react-lite";
import { Outlet } from "react-router-dom";
import LandingHeader from "./LandingHeader.js";
import LandingFooter from "./LandingFooter.js";
import LandingSeo from "../seo/LandingSeo.js";
import { useTranslation } from "../i18n/useTranslation.js";
import ScrollController from "../visuals/ScrollController.js";
import "../styles/index.css";

const LandingLayout = observer(() => {
  const { t } = useTranslation();
  const shellRef = useRef<HTMLDivElement>(null);
  return (
    <div ref={shellRef} className="landing-shell">
      <ScrollController containerRef={shellRef} />
      <a className="landing-skip-link" href="#landing-main">{t("landing.nav.skip")}</a>
      <LandingSeo />
      <LandingHeader />
      <main id="landing-main">
        <Outlet />
      </main>
      <LandingFooter />
    </div>
  );
});

export default LandingLayout;
